const wrapper = "_35swk1abh8";
const dragOverlayContent = "_35sdkrup9n";

export { dragOverlayContent, wrapper };
import "./container.input.style.linaria.module.css";
//# sourceMappingURL=container.input.style.js.map
